<app-message
    [successMessage]="false"
    [messageTitle]="'messages.invalid-session.title' | translate"
    [message]="'messages.invalid-session.description' | translate"
>
</app-message>
